import '../styles/index.scss';
import 'slick-carousel/slick/slick';
import 'bootstrap';
import functions from './functions.js';
import search from './search';

// import search from './search';

class Main {
    constructor() {
        this.onDOMLoaded();
        this.onDocumentLoad();
        this.onResize();
        this.onScroll();
        window.jQuery = window.$ = $;
    }

    onDocumentLoad() {
        window.addEventListener("load", (event) => {
            /******/
            (function (modules) { // webpackBootstrap
                /******/ 	// The module cache
                /******/
                var installedModules = {};
                /******/
                /******/ 	// The require function
                /******/
                function __webpack_require__(moduleId) {
                    /******/
                    /******/ 		// Check if module is in cache
                    /******/
                    if (installedModules[moduleId]) {
                        /******/
                        return installedModules[moduleId].exports;
                        /******/
                    }
                    /******/ 		// Create a new module (and put it into the cache)
                    /******/
                    var module = installedModules[moduleId] = {
                        /******/            i: moduleId,
                        /******/            l: false,
                        /******/            exports: {}
                        /******/
                    };
                    /******/
                    /******/ 		// Execute the module function
                    /******/
                    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
                    /******/
                    /******/ 		// Flag the module as loaded
                    /******/
                    module.l = true;
                    /******/
                    /******/ 		// Return the exports of the module
                    /******/
                    return module.exports;
                    /******/
                }

                /******/
                /******/
                /******/ 	// expose the modules object (__webpack_modules__)
                /******/
                __webpack_require__.m = modules;
                /******/
                /******/ 	// expose the module cache
                /******/
                __webpack_require__.c = installedModules;
                /******/
                /******/ 	// define getter function for harmony exports
                /******/
                __webpack_require__.d = function (exports, name, getter) {
                    /******/
                    if (!__webpack_require__.o(exports, name)) {
                        /******/
                        Object.defineProperty(exports, name, {enumerable: true, get: getter});
                        /******/
                    }
                    /******/
                };
                /******/
                /******/ 	// define __esModule on exports
                /******/
                __webpack_require__.r = function (exports) {
                    /******/
                    if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
                        /******/
                        Object.defineProperty(exports, Symbol.toStringTag, {value: 'Module'});
                        /******/
                    }
                    /******/
                    Object.defineProperty(exports, '__esModule', {value: true});
                    /******/
                };
                /******/
                /******/ 	// create a fake namespace object
                /******/ 	// mode & 1: value is a module id, require it
                /******/ 	// mode & 2: merge all properties of value into the ns
                /******/ 	// mode & 4: return value when already ns object
                /******/ 	// mode & 8|1: behave like require
                /******/
                __webpack_require__.t = function (value, mode) {
                    /******/
                    if (mode & 1) value = __webpack_require__(value);
                    /******/
                    if (mode & 8) return value;
                    /******/
                    if ((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
                    /******/
                    var ns = Object.create(null);
                    /******/
                    __webpack_require__.r(ns);
                    /******/
                    Object.defineProperty(ns, 'default', {enumerable: true, value: value});
                    /******/
                    if (mode & 2 && typeof value != 'string') for (var key in value) __webpack_require__.d(ns, key, function (key) {
                        return value[key];
                    }.bind(null, key));
                    /******/
                    return ns;
                    /******/
                };
                /******/
                /******/ 	// getDefaultExport function for compatibility with non-harmony modules
                /******/
                __webpack_require__.n = function (module) {
                    /******/
                    var getter = module && module.__esModule ?
                        /******/            function getDefault() {
                            return module['default'];
                        } :
                        /******/            function getModuleExports() {
                            return module;
                        };
                    /******/
                    __webpack_require__.d(getter, 'a', getter);
                    /******/
                    return getter;
                    /******/
                };
                /******/
                /******/ 	// Object.prototype.hasOwnProperty.call
                /******/
                __webpack_require__.o = function (object, property) {
                    return Object.prototype.hasOwnProperty.call(object, property);
                };
                /******/
                /******/ 	// __webpack_public_path__
                /******/
                __webpack_require__.p = "";
                /******/
                /******/
                /******/ 	// Load entry module and return exports
                /******/
                return __webpack_require__(__webpack_require__.s = 0);
                /******/
            })
                /************************************************************************/
                /******/ ({

                /***/ "./src/js/bundle.js":
                /*!**************************!*\
                  !*** ./src/js/bundle.js ***!
                  \**************************/
                /*! no static exports found */
                /***/ (function (module, exports) {

                    $(document).ready(function () {
                        $('#play-sound').on('click', function (e) {
                            e.preventDefault();
                            $(this).toggleClass('active');

                            if ($(this).hasClass('active')) {
                                document.getElementById('audio').pause();
                            } else {
                                document.getElementById('audio').play();
                            }
                        });
                        $('#play-sound-2').on('click', function (e) {
                            e.preventDefault();
                            $(this).toggleClass('active');

                            if ($(this).hasClass('active')) {
                                document.getElementById('audio').pause();
                            } else {
                                document.getElementById('audio').play();
                            }
                        });

                        if ($(window).width() > 1199) {
                            $('.img-magnifier-container').each(function (e) {
                                var targetId = $(this).find('img').attr("id");
                                magnify(targetId, 2);
                            });
                        }

                        $('#header').css('height', $('.header__inner').height());
                        $('.selena-btn').on('click', function (e) {
                            e.preventDefault();
                            var href = $(this).attr('href');

                            if (href[0] != '#') {
                                window.location.href = href;
                            } else {
                                $('html, body').animate({
                                    scrollTop: $(href).offset().top - $('.header__inner').height()
                                }, 500);
                            }
                        });

                        if ($(window).width() < 1199) {
                            $('.products-list').slick({
                                slidesToShow: 5,
                                infinite: true,
                                responsive: [{
                                    breakpoint: 992,
                                    settings: {
                                        slidesToShow: 3,
                                        slidesToScroll: 1,
                                        infinite: true,
                                        dots: true
                                    }
                                }, {
                                    breakpoint: 600,
                                    settings: {
                                        slidesToShow: 2,
                                        slidesToScroll: 2
                                    }
                                }, {
                                    breakpoint: 480,
                                    settings: {
                                        slidesToShow: 1,
                                        slidesToScroll: 1
                                    }
                                }]
                            });
                        }

                        if ($(window).width() < 992) {
                            $('.section-1 .kafelki').slick({
                                slidesToShow: 1,
                                infinite: true,
                                arrows: true
                            });
                        }

                        if ($(window).width() < 768) {
                            $('.red-list').slick({
                                slidesToShow: 1,
                                infinite: true,
                                dots: true
                            });
                            $('.section-4 .kafelki').slick({
                                slidesToShow: 2,
                                infinite: true,
                                arrows: true,
                                dots: true,
                                responsive: [{
                                    breakpoint: 575,
                                    settings: {
                                        slidesToShow: 1,
                                        slidesToScroll: 1
                                    }
                                }]
                            });
                        }
                    });

                    function magnify(imgID, zoom) {
                        var img, glass, w, h, bw;
                        img = document.getElementById(imgID);
                        glass = document.createElement("DIV");
                        glass.setAttribute("class", "img-magnifier-glass");
                        img.parentElement.insertBefore(glass, img);
                        glass.style.backgroundImage = "url('" + img.src + "')";
                        glass.style.backgroundRepeat = "no-repeat";
                        glass.style.backgroundSize = img.width * zoom + "px " + img.height * zoom + "px";
                        bw = 3;
                        w = glass.offsetWidth / 2;
                        h = glass.offsetHeight / 2;
                        glass.addEventListener("mousemove", moveMagnifier);
                        img.addEventListener("mousemove", moveMagnifier);
                        glass.addEventListener("touchmove", moveMagnifier);
                        img.addEventListener("touchmove", moveMagnifier);

                        function moveMagnifier(e) {
                            var pos, x, y;
                            e.preventDefault();
                            pos = getCursorPos(e);
                            x = pos.x;
                            y = pos.y;

                            if (x > img.width - w / zoom) {
                                x = img.width - w / zoom;
                            }

                            if (x < w / zoom) {
                                x = w / zoom;
                            }

                            if (y > img.height - h / zoom) {
                                y = img.height - h / zoom;
                            }

                            if (y < h / zoom) {
                                y = h / zoom;
                            }

                            glass.style.left = x - w + "px";
                            glass.style.top = y - h + "px";
                            glass.style.backgroundPosition = "-" + (x * zoom - w + bw) + "px -" + (y * zoom - h + bw) + "px";
                        }

                        function getCursorPos(e) {
                            var a,
                                x = 0,
                                y = 0;
                            e = e || window.event;
                            a = img.getBoundingClientRect();
                            x = e.pageX - a.left;
                            y = e.pageY - a.top;
                            x = x - window.pageXOffset;
                            y = y - window.pageYOffset;
                            return {
                                x: x,
                                y: y
                            };
                        }
                    }

                    /***/
                }),

                /***/ 0:
                /*!********************************!*\
                  !*** multi ./src/js/bundle.js ***!
                  \********************************/
                /*! no static exports found */
                /***/ (function (module, exports, __webpack_require__) {

                    module.exports = __webpack_require__(/*! C:\dev\tytan\src\js\bundle.js */"./src/js/bundle.js");


                    /***/
                })

                /******/
            });


            // $(document).ready(function () {
            //     $(".wpcf7-acceptance .wpcf7-list-item-label").each(function () {
            //         var maxLength = 120;
            //         var myStr = $(this).html();
            //         if ($.trim(myStr).length > maxLength) {
            //             var newStr = myStr.substring(0, maxLength);
            //             var removedStr = myStr.substring(maxLength, $.trim(myStr).length);
            //             $(this).empty().html(newStr);
            //             $(this).append('<span class="read-more">&hellip;&nbsp;<a href="javascript:void(0);">Czytaj więcej</a></span>');
            //             $(this).append('<span class="more-text">' + removedStr + '</span>');
            //         }
            //     });
            //
            //     $(document).on("click", ".read-more", function () {
            //         $(this).siblings(".more-text").contents().unwrap();
            //         $(this).remove();
            //     });
            //
            // });
        });
    }

    onDOMLoaded() {
        document.addEventListener("DOMContentLoaded", (event) => {
            functions.cookies();
            functions.carousel();
            functions.togglePopup();
            search.searchForProducts();
        });

    }

    onResize() {
        window.addEventListener('resize', (event) => {

        });
    }

    onScroll() {
        window.addEventListener('scroll', (event) => {

        });
    }

}

new Main();





// WEBPACK FOOTER //
// ./src/scripts/index.js